<template>
  <div>
    <van-nav-bar @click-left="onClickLeft" @click-right="modifyData.isShowNum++" :border="false">
    <span slot="left" style="font-size: 17px">
       <van-icon color="black" name="arrow-left"></van-icon>
    </span>
      <span slot="right" style="font-size: 17px">
       <van-icon color="black" :name="icon.searchBlack"></van-icon>
    </span>
      <span slot="title" style="font-size: 17px;color: #505050">分类</span>
    </van-nav-bar>
    <div style="display: flex;background: #F6F7F8;height: calc(100vh - 56px - 15.3vw);">
      <van-sidebar v-model="category" style="height: calc(100vh - 56px - 15.3vw);background: #F6F7F8;">
        <van-sidebar-item v-for="(item, index) in categorys" @click="categoryChange2(item)" :key="item.id">
          <div slot="title">
            {{item.categoryName}}
            <div v-if="category === index" style="position: absolute; top: -1.87vw;right: 0;display: flex">
              <img src="../../../assets/img/roundTop.png" style="width: 1.87vw;height: 1.87vw">
            </div>
            <div v-if="index === category + 1" style="position: absolute; top: 0;right: 0;display: flex">
              <img src="../../../assets/img/roundBottom.png" style="width: 1.87vw;height: 1.87vw">
            </div>
          </div>
        </van-sidebar-item>
      </van-sidebar>
      <div ref="categoryAll" @scroll="scrollCategory" style="overflow-y: auto;padding-left: 3.47vw;background: white;position: relative">
        <div :ref="'categoryItem' + index" v-for="(item, index) in babyList" :key="item.id">
          <div style="position: relative;justify-content: left;font-size: 3.73vw;margin-bottom: 3.47vw" class="centerBox">
            <div style="width: .53vw;height: 2.93vw;background: #da3939;margin-right: 1.87vw"></div>
            {{categoryName}}
          </div>
<!--          @plusTwo="changeCartGoodsNumTwo(arguments)" @minusTwo="minusCartGoodsNumTwo(arguments)"-->
          <my-shop-list @expend="changeExpend" @plus="changeCartGoodsNum(children, 1)" @minus="changeCartGoodsNum(children, 2)" v-for="children in item.list" :key="children.id" :row="children" :source="source" style="margin: 4.8vw 0;">
          </my-shop-list>
        </div>
        <div v-if="pList.length > 0">
          <div style="position: relative;justify-content: left;font-size: 3.73vw;margin-bottom: 3.47vw" class="centerBox">
          <div style="width: .53vw;height: 2.93vw;background: #da3939;margin-right: 1.87vw"></div>
          <span>拼箱商品</span>
        </div>
        <div :ref="'categoryItem' + index" v-for="(item, index) in pList" :key="item.id">
          <p-list @plusTwo2="addPinSecorend(arguments)" @minusTwo2="jjPinSecorend(arguments)" @expend="changeExpend" :row="item" style="margin: 4.8vw 0;">
          </p-list>
        </div>
        </div>
      </div>
    </div>
    <search @onSearch="onSearch" :is-show-num="modifyData.isShowNum"></search>
    <shop-inquire @back="modifyData.isShowNum++" :is-show-num="modifyDataInquire.isShowNum" :row="modifyDataInquire.row"></shop-inquire>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import searchBlack from '../../../assets/img/icon/searchBlack.png'
export default {
  name: 'ShopSearch',
  data () {
    return {
      source: 0,
      category: 0,
      shopShow: false,
      icon: {
        searchBlack
      },
      modifyDataInquire: {
        isShowNum: 0,
        row: {}
      },
      isScroll: true,
      categorys: [],
      babyList: [],
      pList: [],
      trueItem: {},
      categoryName: '',
      modifyData: {
        isShowNum: 0
      }
    }
  },
  computed: {
  },
  created () {
    this.$toast.clear()
  },
  mounted () {
    // this.selectCategory()
    this.selectCategory2()
    this.set_keepAliveList([])
  },
  watch: {
  },
  destroyed () {
    // clearInterval(this.categoryTime)
  },
  methods: {
    ...mapActions([
      'set_keepAliveList'
    ]),
    onSearch (value) {
      this.modifyDataInquire.isShowNum++
      this.modifyDataInquire.row = {
        title: value,
        type: 'text'
      }
    },
    changeExpend (item) {
      item.show = !item.show
    },
    // 第一次增加主品
    addCart (children) {
      const self = this
      self.$toast.loading({
        duration: 0
      })
      console.log(children)
      if (children.minGoodsList) {
        children.minGoodsList.forEach(item => {
          this.$set(item, 'goodsId', item.minId)
          this.$set(item, 'imgPath', item.goodsImg)
          this.$set(item, 'qty', 0)
        })
      }
      self.$request.shop.addCartGoods({
        qty: children.miniBuyQty,
        ...children,
        goodsId: children.id,
        miniBuyQty: children.miniBuyQty,
        minCartGoodsList: children.minGoodsList,
        containerLoad: children.containerLoad,
        specificationQty: children.specificationQty
      })
        .then((response) => {
          self.$toast.clear()
          if (response.code === '200') {
            // children.buyQty += children.miniBuyQty
            this.categoryChange2(this.trueItem)
          } else {
            // console.log(response)
            self.$toast(response.msg)
          }
        })
    },
    // 第一次增加附属品
    // addCartTwo (row, children) {
    //   // console.log(row)
    //   const self = this
    //   const minCartGoodsList = []
    //   console.log(row)
    //   if (row) {
    //     minCartGoodsList.push({
    //       category: row.category,
    //       goodsId: row.minId,
    //       goodsName: row.goodsName,
    //       qty: row.miniBuyQty,
    //       imgPath: row.goodsImg,
    //       price: row.price,
    //       unitPrice: row.unitPrice
    //     })
    //   }
    //   self.$toast.loading({
    //     duration: 0
    //   })
    //   self.$request.shop.addCartGoods({
    //     qty: children.specificationQty,
    //     ...children,
    //     goodsId: children.id,
    //     mainGoodsAddFlag: 1,
    //     miniBuyQty: children.miniBuyQty,
    //     minCartGoodsList: minCartGoodsList
    //   })
    //     .then((response) => {
    //       self.$toast.clear()
    //       if (response.code === '200') {
    //         // children.buyQty++
    //         this.categoryChange2(this.trueItem)
    //       } else {
    //         // console.log(response)
    //         self.$toast(response.msg)
    //       }
    //     })
    // },
    // 第二次增加主品
    changeCartGoodsNum (children, type) {
      if (!children.buyQty) {
        this.addCart(children)
        return
      }
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.changeCartGoodsNum({
        ...children,
        goodsId: children.id,
        miniBuyQty: children.miniBuyQty,
        qty: children.miniBuyQty,
        containerLoad: children.containerLoad,
        opFlag: type
      })
        .then((response) => {
          this.$toast.clear()
          if (response.code === '200') {
            this.categoryChange2(this.trueItem)
          } else {
            this.$toast(response.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 第二次增加附属品
    // changeCartGoodsNumTwo (data) {
    //   // console.log(data[1])
    //   if (data[1].buyQty > 0) {
    //     if (!data[0].buyQty) {
    //       this.addCartTwo(data[0], data[1])
    //       return
    //     }
    //     this.$toast.loading({
    //       duration: 0
    //     })
    //     // console.log(data)
    //     const minCartGoodsList = []
    //     if (data[0]) {
    //       minCartGoodsList.push({
    //         category: data[0].category,
    //         goodsId: data[0].minId,
    //         opFlag: 1
    //       })
    //     }
    //     this.$request.shop.changeCartGoodsNum({
    //       goodsId: data[1].id,
    //       category: data[1].category,
    //       opFlag: 0,
    //       miniBuyQty: data[1].miniBuyQty,
    //       minCartGoodsList: minCartGoodsList
    //     })
    //       .then((response) => {
    //         this.$toast.clear()
    //         if (response.code === '200') {
    //           this.categoryChange2(this.trueItem)
    //         } else {
    //           this.$toast(response.msg)
    //         }
    //       })
    //       .catch((error) => {
    //         console.log(error)
    //       })
    //   } else {
    //     this.$toast('请选择主商品')
    //   }
    // },
    // 第二次减少附属品
    // minusCartGoodsNumTwo (data) {
    //   // console.log(data[1])
    //   if (!data[0].buyQty) {
    //     this.addCart(data[0])
    //     return
    //   }
    //   this.$toast.loading({
    //     duration: 0
    //   })
    //   const minCartGoodsList = []
    //   if (data[0]) {
    //     minCartGoodsList.push({
    //       category: data[0].category,
    //       goodsId: data[0].minId,
    //       opFlag: 2
    //     })
    //   }
    //   this.$request.shop.changeCartGoodsNum({
    //     ...data[1],
    //     goodsId: data[1].id,
    //     opFlag: 0,
    //     miniBuyQty: data[1].miniBuyQty,
    //     minCartGoodsList: minCartGoodsList
    //   })
    //     .then((response) => {
    //       this.$toast.clear()
    //       if (response.code === '200') {
    //         this.categoryChange2(this.trueItem)
    //       } else {
    //         this.$toast(response.msg)
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error)
    //     })
    // },
    // 第二次增加拼箱
    // 加拼箱
    addPinSecorend (data) {
      this.$toast.loading({
        duration: 0
      })
      console.log(data[0]) // 里面
      console.log(data[1]) // 外面
      let a = 0
      data[1].shopGoodsVOList.forEach(item => {
        if (item.buyQty) {
          a++
        }
      })
      if (!a) {
        this.addPinFirst(data[0], data[1])
        return
      }
      const containerLoadGoodsList = []
      if (data[0]) {
        containerLoadGoodsList.push({
          category: data[0].category,
          goodsId: data[0].id,
          containerLoadId: data[1].id,
          qty: data[0].hsgMiniBuyQty,
          containerLoad: data[0].containerLoad,
          opFlag: 1
        })
      }
      this.$request.shop.changeCartGoodsNum2({
        goodsId: data[1].id,
        category: data[0].category,
        opFlag: 0,
        containerLoadName: data[1].containerLoadName,
        miniBuyQty: data[1].miniBuyQty,
        containerLoadGoodsList: containerLoadGoodsList
      })
        .then((response) => {
          if (response.code === '200') {
            this.categoryChange2(this.trueItem)
          } else {
            this.$toast(response.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 第二次减少拼箱
    jjPinSecorend (data) {
      this.$toast.loading({
        duration: 0
      })
      const containerLoadGoodsList = []
      if (data[0]) {
        containerLoadGoodsList.push({
          category: data[0].category,
          goodsId: data[0].id,
          containerLoadId: data[1].id,
          qty: data[0].hsgMiniBuyQty,
          opFlag: 2
        })
      }
      this.$request.shop.changeCartGoodsNum2({
        goodsId: data[1].id,
        category: data[0].category,
        opFlag: 0,
        containerLoadName: data[1].containerLoadName,
        miniBuyQty: data[1].miniBuyQty,
        containerLoad: data[0].containerLoad,
        containerLoadGoodsList: containerLoadGoodsList
      })
        .then((response) => {
          if (response.code === '200') {
            this.categoryChange2(this.trueItem)
          } else {
            this.$toast(response.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 第一次增加拼箱
    addPinFirst (row, children) {
      const self = this
      self.$toast.loading({
        duration: 0
      })
      console.log(row)
      console.log(children)
      children.shopGoodsVOList.forEach(item => {
        this.$set(item, 'goodsId', item.id)
        this.$set(item, 'imgPath', item.goodsImg)
        this.$set(item, 'containerLoadId', children.id)
        this.$set(item, 'qty', 0)
        item.miniBuyQty = item.hsgMiniBuyQty
      })
      children.shopGoodsVOList.forEach(item => {
        if (item.id === row.id) {
          this.$set(item, 'goodsId', item.id)
          this.$set(item, 'imgPath', item.goodsImg)
          this.$set(item, 'containerLoadId', children.id)
          this.$set(item, 'qty', row.hsgMiniBuyQty)
          item.miniBuyQty = item.hsgMiniBuyQty
        }
      })
      self.$request.shop.addCartGoods2({
        qty: children.specificationQty,
        ...children,
        category: row.category,
        mainGoodsAddFlag: 1,
        miniBuyQty: children.miniBuyQty,
        containerLoad: children.id,
        containerLoadGoodsList: children.shopGoodsVOList
      })
        .then((response) => {
          // self.$toast.clear()
          if (response.code === '200') {
            // children.buyQty++
            this.categoryChange2(this.trueItem)
          } else {
            // console.log(response)
            self.$toast(response.msg)
          }
        })
    },
    // 老版列表
    selectCategory () {
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.pageCategory()
        .then((response) => {
          this.$toast.clear()
          response.data.forEach(item => {
            item.list.forEach(item2 => {
              this.$set(item2, 'show', false)
              if (this.categorys.length) {
                this.categorys.forEach(cate => {
                  cate.list.forEach(cates => {
                    if (item2.id === cates.id && cates.show) {
                      item2.show = true
                    }
                  })
                })
              }
            })
          })
          this.categorys = response.data
          setTimeout(() => {
            this.categorys.forEach((item, index) => {
              item.top = this.$refs['categoryItem' + index][0].offsetTop - 54
              // console.log(item)
            })
            if (this.$route.query.index) {
              this.category = Number(this.$route.query.index)
              this.categoryChange(Number(this.$route.query.index))
            }
          }, 50)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 新版查分类
    selectCategory2 () {
      // console.log(this.babyList)
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.pageCategory2()
        .then((response) => {
          this.$toast.clear()
          this.categorys = response.data
          this.trueItem = response.data[0]
          // setTimeout(() => {
          //   this.categorys.forEach((item, index) => {
          //     item.top = this.$refs['categoryItem' + index][0].offsetTop - 54
          //     // console.log(item)
          //   })
          if (this.$route.query.index) {
            this.category = Number(this.$route.query.index)
            this.categoryChange2(this.categorys[this.category])
          } else {
            this.categoryChange2(this.trueItem)
          }
          // }, 50)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 老版滚动啥的
    // categoryChange (index) {
    //   this.isScroll = false
    //   this.$refs.categoryAll.scrollTop = this.categorys[index].top
    //   setTimeout(() => {
    //     this.isScroll = true
    //   }, 1)
    // },
    // 点击分类列表
    categoryChange2 (item) {
      this.$toast.loading({
        duration: 0
      })
      // 当前选中
      this.trueItem = item
      this.$route.query.index = ''
      // console.log(this.babyList)
      this.categoryName = item.categoryName
      // 查商品
      this.$request.shop.listCategoryById({ id: item.id })
        .then((response) => {
          response.data.forEach(item => {
            item.list.forEach(item2 => {
              this.$set(item2, 'show', false)
              if (this.babyList.length) {
                this.babyList.forEach(cate => {
                  cate.list.forEach(cates => {
                    if (item2.id === cates.id && cates.show) {
                      item2.show = true
                    }
                  })
                })
              }
            })
          })
          // 商品列表listCategoryContainerLoadById
          this.babyList = response.data
          //  查询拼箱
          this.$request.shop.listCategoryContainerLoadById({ containerLoadClassify: item.id })
            .then(res => {
              res.data.forEach(item => {
                this.$set(item, 'show', false)
                if (this.pList.length) {
                  this.pList.forEach(item2 => {
                    if (item.id === item2.id && item2.show) {
                      item.show = true
                    }
                  })
                }
              })
              this.pList = res.data
              this.$toast.clear()
            })
        })
      // this.isScroll = false
      // this.$refs.categoryAll.scrollTop = this.categorys[index].top
      // setTimeout(() => {
      //   this.isScroll = true
      // }, 1)
    },
    // 老版滚动啥的
    scrollCategory () {
      // console.log(this.$refs.categoryAll.scrollTop, this.$refs.categoryAll.scrollHeight)
      if (this.isScroll) {
        for (let i = this.categorys.length - 1; i >= 0; i--) {
          if (this.categorys[i + 1] && this.$refs.categoryAll.scrollTop < this.categorys[i + 1].top && this.$refs.categoryAll.scrollTop > this.categorys[i].top) {
            this.category = i
            return
          } else if (!this.categorys[i + 1] && this.$refs.categoryAll.scrollTop > this.categorys[i].top) {
            this.category = i
            return
          }
        }
      }
    },
    // 不知道的校验
    buyShop (skuData) {
      if (this.currentQty > skuData.selectedSkuComb.stock_num) {
        this.$toast('库存不足')
        return
      }
      this.addCart(skuData)
    },
    // 返回
    onClickLeft () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
/* 禁用移动端图片点击放大功能 */
img {
  -webkit-touch-callout: none; /* iOS Safari 禁用长按菜单 */
  -webkit-user-select: none; /* 禁用选择 */
  user-select: none; /* 禁用选择 */
  -webkit-user-drag: none; /* 禁用拖拽 */
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
}
</style>
